/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const Award1 = ({ className }) => {
  return (
    <svg
      className={`award-1 ${className}`}
      fill="none"
      height="26"
      viewBox="0 0 24 26"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M12 16C15.866 16 19 12.866 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.866 8.13401 16 12 16Z"
        stroke="var(--primario)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.3"
      />

      <path
        className="path"
        d="M8.21 14.8899L7 23.9999L12 20.9999L17 23.9999L15.79 14.8799"
        stroke="var(--primario)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.3"
      />
    </svg>
  );
};
